<template>
  <div class="question-box">
    <div class="question-title">
      <div style="display:flex;">
        {{index+1}}.
        <span v-html="questionContent.content"></span>
      </div>
      <viewer :images="questionContent.file" class="question-title-imgbox" v-if="questionContent.file && questionContent.file.length">
        <img v-for="(src,index) in questionContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>

    <div class="question-answer">
      <span>正确答案：</span>
      <p v-for="(item,idx) in optionsContent" :key="idx">
        <span style="color: red;">第{{idx+1}}空：</span>
        {{item.content}}
      </p>
    </div>
    <div class="question-answer notop" :class="!is_right?'is-wrong':'is-right'">
      <span>{{name}}的答案：</span>
      <span v-if="!fillAnswer" style="color:red;">未填写答案</span>
      <p v-for="(item,idx) in fillAnswer" :key="idx">
        <span style="color: red;">第{{idx+1}}空：</span>
        {{item}}
      </p>
      <span class="it-li">+{{student_score}}分</span>
    </div>
    <div class="question-analysis" v-if="analysisContent.content">
      <span>答案解析:</span>
      {{analysisContent.content}}
      <viewer :images="analysisContent.file">
        <img v-for="(src,index) in analysisContent.file" :src="src.url" :key="index" class="option-img">
      </viewer>
    </div>
  </div>
</template>

<script>
export default {
  props: ['itemContent', 'index', 'currentIndex', 'name'],
  watch: {
    currentIndex: function () {
      this.initData()
    }
  },
  data() {
    return {
      fillAnswer: [],//答案
      optionsContent: [],
      questionContent: {},//题干数据保存
      analysisContent: {},//解析数据保存
      titleId: '',
      score: '',
      student_score: '',
      is_right: '',
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    initData: function () {
      this.fillAnswer = this.itemContent.student_answer
      this.titleId = this.itemContent.id
      this.optionsContent = this.itemContent.answer
      this.questionContent = this.itemContent.topic_title
      this.analysisContent = this.itemContent.parsing
      this.is_right = this.itemContent.right_and_wrong
      this.score = this.itemContent.score
      this.student_score = this.itemContent.single_topic_score
    }
  },
}
</script>

<style scoped="">
</style>